import $ from "jquery"
import '.././less/plugin-image.less';

import FluxEditorEvents from '../events';
import FluxEditorTooltip from '../tooltip';
import editTemplate from 'raw-loader!.././templates/image-edit-widget.html'
import widgetTemplate from 'raw-loader!.././templates/image-widget.html'

function FluxEditorImage(options) {
  this.defaults = {
    editTemplate: editTemplate,
    widgetTemplate: widgetTemplate,
    selectors: ['figure[class~="flux-image"]'],
    identifier: 'flux-editor-image',
    tooltipItemTitle: 'New image',
    linkPlaceholder: 'Copy/paste your link here and press enter.',
    accessibilityPlaceholder: 'Image title for accessibility.',
    events: {
      onNewElement: function(args ) { return args }
    }
  };
  this.settings = Object.assign({}, this.defaults, options);

  FluxEditorEvents(this);
  this.registerEvents();
}

FluxEditorImage.prototype.getSelectors = function() {
  return this.settings.selectors;
}

FluxEditorImage.prototype.getIdentifier = function() {
  return this.settings.identifier;
}

FluxEditorImage.prototype.registerEvents = function() {
  var _this = this;
  if (typeof this.settings.events == 'object') {
    $.each(this.settings.events, function(i,  f) {
      _this.on(i, f);
    });
  }
}

FluxEditorImage.prototype.getTooltipItem = function(context) {
  return {
    title: this.settings.tooltipItemTitle,
    className: 'flux-editor-image-tooltip-item',
    plugin: this,
    method: 'addNewElement',
    arguments: context
  }
}

FluxEditorImage.prototype.addNewElement = function(args) {
  this.emit('onNewElement', {
    plugin: this,
    fluxElementIndex: args.fluxElementIndex,
    core: args.core
  });
}

FluxEditorImage.prototype.insertNewElement = function(properties, index, core) {
  if (properties.src) {
    core.insertNewEditableContentAfter(index, this, {
      src: properties.src,
      caption: properties.caption,
      accessibility: properties.accessibility
    });
  }
}

FluxEditorImage.prototype.getContent = function(el) {
  var $img = $(el).find('img');
  var $caption = $(el).find('figcaption');
  var $a = $(el).find('a');

  const content = {
    src: $img.attr('src'),
    caption: $caption.html() ? $caption.html() : null,
    accessibility: $img.attr('title'),
    link: $a.length > 0 ? $a.attr('href') : null
  }

  return content
}

FluxEditorImage.prototype.getHTML = function(content, core) {
  this.___code = core
  var $figure = $(this.settings.widgetTemplate);
  var $img = $figure.find('img')

  $img.attr('src', content.src);
  $img.attr('title', content.accessibility);
  $img.attr('alt', content.accessibility);

  if (content.link) {
    $img.wrap(`<a href="${content.link}"></a>`)
  }

  if (content.caption) {
    $figure.find('figcaption').html(content.caption);
  } else {
    $figure.find('figcaption').remove()
  }
  return $figure[0].outerHTML;
}

FluxEditorImage.prototype.getEditableElement = function(content, core) {
  var $figure = $(this.settings.editTemplate);
  var $img = $('img', $figure);
  var $imgContainer = $figure.find('.flux-editor-image-container');
  var $caption = $figure.find('figcaption');
  var $link = $figure.find('.flux-editor-image-link-value');
  var $accessibility = $figure.find('.flux-editor-image-accessibility-value');
  var $linkDisplay = $figure.find('.flux-editor-image-link-display');

  $img.attr('src', content.src);
  $img.attr('title', content.accessibility);
  $img.attr('alt', content.accessibility);
  $caption.html(content.caption);
  $link.val(content.link);
  $link.attr('placeholder', this.settings.linkPlaceholder);
  $accessibility.val(content.accessibility);
  $accessibility.attr('placeholder', this.settings.accessibilityPlaceholder);

  $linkDisplay.css('top', $img.position().top)
  if (content.src || content.src != '#') {
    $linkDisplay.attr('href', content.link)
    $linkDisplay.attr('title', `Go to ${content.link}`)
  } else {
    $linkDisplay.hide()
  }


  $img.click(function (){
    var tooltip = new FluxEditorTooltip();

    // Accessibility
    tooltip.addItem({
      className: 'flux-editor-image-tooltip-accessibility',
      callback: function () {
        $accessibility.parent().removeClass('d-none')
        $accessibility.focus()
      }
    });

    // link
    tooltip.addItem({
      className: 'flux-editor-image-tooltip-link',
      callback: function () {
        $link.parent().removeClass('d-none')
        $link.focus()
      }
    });

    // move
    tooltip.addItem({
      className: 'flux-editor-image-tooltip-arrowup',
      callback: function () {
        core.moveEditableContent(content.fluxElementIndex, 'up');
      }
    });
    tooltip.addItem({
      className: 'flux-editor-image-tooltip-arrowdown',
      callback: function () {
        core.moveEditableContent(content.fluxElementIndex, 'down');
      }
    });

    // remove
    tooltip.addItem({
      className: 'flux-editor-image-tooltip-trash',
      callback: function () {
        core.deleteEditableContent(content.fluxElementIndex);
      }
    });

    tooltip.display(
      $img.offset().top + ($img.height() - 50),
      $img.offset().left + ($img.width() / 2),
      true
    );
  })

  $imgContainer.mouseenter(function () {
    if ($link.val()) {
      $linkDisplay.removeClass('d-none')
    }
  });

  $imgContainer.mouseleave(function () {
    $linkDisplay.addClass('d-none')
  });

  $link.on('keyup', function(e) {
    if (e.keyCode === 13) {
      $link.parent().addClass('d-none')
      content.link = $link.val()
      $linkDisplay.attr('title', $link.val())
      $linkDisplay.attr('href', $link.val())
      core.updateContent(content.fluxElementIndex);
    }
  })

  $figure.find('.flux-editor-image-link-confirm').on('click', function() {
    $link.parent().addClass('d-none')
    content.link = $link.val()
    $linkDisplay.attr('title', $link.val())
    $linkDisplay.attr('href', $link.val())
    core.updateContent(content.fluxElementIndex);
    return false;
  })

  $figure.find('.flux-editor-image-link-cancel').on('click', function() {
    $link.parent().addClass('d-none')
    return false;
  })

  $accessibility.on('keyup', function(e) {
    if (e.keyCode === 13) {
      $accessibility.parent().addClass('d-none')
      content.accessibility = $accessibility.val()
      $img.attr('title', $accessibility.val())
      $img.attr('alt', $accessibility.val())
      core.updateContent(content.fluxElementIndex);
    }
  })

  $figure.find('.flux-editor-image-accessibility-confirm').on('click', function() {
    $accessibility.parent().addClass('d-none')
    content.accessibility = $accessibility.val()
    core.updateContent(content.fluxElementIndex);
    return false;
  })

  $figure.find('.flux-editor-image-accessibility-cancel').on('click', function() {
    $accessibility.parent().addClass('d-none')
    return false;
  })

  // caption
  $caption.addClass('flux-editor-image-caption');
  $caption.attr('placeholder', 'Add caption');
  $caption.mouseenter(function () {
    $(this).attr('contenteditable', 'true');
  });

  $caption.mouseleave(function () {
    $(this).removeAttr('contenteditable');
    $(this).blur();
    core.updateContent(content.fluxElementIndex);
  });

  $caption.on('paste', function( e) {
    e.stopPropagation();
    e.preventDefault();

    var clipboardData = e.originalEvent.clipboardData || window.clipboardData;
    var pastedData = clipboardData.getData('Text');
    var $pasted = $('<span></span>').html(pastedData);
    core.insertAtCaret($pasted[0]);
    core.updateContent(content.fluxElementIndex);

    return false;
  });

  return $figure;
}

export default FluxEditorImage;
